export type ThemePreference = 'dark' | 'light' | 'system';

export function applyTheme(theme: ThemePreference): void {
  const root = document.documentElement;
  root.classList.remove('dark', 'light');
  if (theme === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.classList.add(prefersDark ? 'dark' : 'light');
  } else {
    root.classList.add(theme);
  }
}

export function initTheme(): void {
  const saved = (localStorage.getItem('theme-preference') as ThemePreference | null) ?? 'dark';
  applyTheme(saved);
}
